import { createSelector } from 'reselect';

import * as c from 'constants/productUnitsDB';

export default (state = [], { type, payload }) => {
  switch (type) {
    case c.SET_PRODUCTUNITS:
      return payload;
    default:
      return state;
  }
};

export const getProductUnits = state => state.productUnitsDB;

// temp fix for production issue with clients getting weight popup for every product unit
// todo migrate to PIM API for manipulations with product units, request update on API level to determine what units should require unit prompt
export const getWeightedProductUnits = state => [
  'kg',
  'hg',
  'dag',
  'g',
  'dg',
  'cg',
  'mg',
  'oz',
  'lb',
];
